"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERROR_INCOMPLETED_DOWNLOAD = exports.ERROR_RESPONSE_BODY_READER = void 0;
exports.ERROR_RESPONSE_BODY_READER = new Error("failed to get response body reader");
exports.ERROR_INCOMPLETED_DOWNLOAD = new Error("failed to complete download");
